<template>
  <section class="hero">
    <div class="container flex-between">
      <div class="intro">
        <h1 class="title">{{ page.title }}</h1>
        <div
          class="description"
          v-html="page.description"
        />
        <ApplyButton
          cta-section="hero-section"
          page-name="lead-gen-page"
          class="proxify-btn proxify-btn-white apply-button"
        />
        <Brands />
      </div>
      <SubscribeForm
        v-if="!subscribed"
        :form-title="page.subscription_title || 'Connect with us'"
        :button-title="page.download_button_title || 'Download PDF'"
        :form-text="page.form_text"
        @subscribed="$emit('subscribed')"
      />
      <SubscribeSuccess
        v-else
        :button-title="page.download_button_title || 'Download PDF'"
        @download-file="$emit('downloadFile')"
      />
    </div>
  </section>
</template>

<script>
import SubscribeForm from './SubscribeForm/SubscribeForm.vue';
import SubscribeSuccess from './SubscribeSuccess/SubscribeSuccess.vue';
import Brands from '~/components/Common/Brands/Brands.vue';
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';

export default {
  components: {
    ApplyButton,
    Brands,
    SubscribeForm,
    SubscribeSuccess,
  },
  props: {
    page: {
      type: Object,
      default: () => {},
    },
    subscribed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['downloadFile', 'subscribed'],
};
</script>

<style lang="scss" scoped>
@import './HeroSection.scss';
</style>
